/* React */
import React from "react";

/* Ionic */
import { IonItem } from "@ionic/react";

/* Constants */
import { ALPHABET } from "src/shared/constants/common/Alphabet";

/* Stylesheet */
import styles from "./LetterContainer.module.scss";

const LetterContainer: React.FC = () => {
  return (
    <div className={styles.letter_container}>
      {ALPHABET.map((letter, index) => {
        return (
          <IonItem key={index} lines="none" button>
            {letter}
          </IonItem>
        );
      })}
    </div>
  );
};

export default LetterContainer;
